import AuthActions from '/b2b/authentication/state/Auth.actions';
import { getMfaOptions } from '/b2b/authentication/state/Auth.selectors';

export const mapStateToProps = state => {
    return {
        hasOtherMFAMethods: getMfaOptions(state).length !== 1,
    };
};

export const mapDispatchToProps = dispatch => {
    return {
        onReselectMFA: () => dispatch(AuthActions.selectMfa('NOMFA')),
    };
};
